import { useGetMachineSetupNames, useGetSpec } from "./";
import _ from "lodash";
import { useEffect, useState } from "react";

export default function useGetMachineSetupForPlanning(item) {
   const { MachineSetupList, MachineSetupSuccess } = useGetMachineSetupNames();
   const { success, spec, loading, prevValue, oneMachineSetupOnly, singleMachine, machineSetupList } = useGetSpec(item);
   const Specification = { success: success, spec: spec, loading: loading, prevValue: prevValue, oneMachineSetupOnly: oneMachineSetupOnly, singleMachine: singleMachine, machineSetupList: machineSetupList };

   const [data, setData] = useState({
      MachineSetupList: [],
      MachineSetupSuccess: false,
      Specification: Specification
   });

   useEffect(() => {
      if (!item) {
         if (!MachineSetupSuccess) return;
         let activeMachines = _.filter(MachineSetupList, (item) => item.isActive);
         setData({
            ...data,
            MachineSetupList: activeMachines,
            MachineSetupSuccess: MachineSetupSuccess
         })
      } else {
         if (!success) return;
         setData({
            ...data,
            MachineSetupList: machineSetupList,
            MachineSetupSuccess: success
         })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [item, MachineSetupSuccess, success])

   return data;
}